import BaseSensorExtension from '../base-sensor';
import formatMessage from 'format-message';

class PIRSensorExtension extends BaseSensorExtension {
    constructor (runtime) {
        super(runtime);
    }

    getSensorInfo () {
        return {
            id: 'pirSensor',
            name: 'PIR Motion',
            color1: '#00BFA5',
            color2: '#00B29A',
            color3: '#009480',

            blocks: [
                {
                    opcode: 'pir_motionDetected',
                    blockType: 'Boolean',
                    text: formatMessage({
                        id: 'pirSensor.blocks.motionDetected',
                        default: 'motion detected on pin [PIN]?'
                    }),
                    arguments: {
                        PIN: {
                            type: 'number',
                            defaultValue: '2',
                            menu: 'digitalPinMenu'
                        }
                    }
                },
                {
                    opcode: 'pir_waitMotion',
                    blockType: 'command',
                    text: formatMessage({
                        id: 'pirSensor.blocks.waitUntil',
                        default: 'wait until motion detected on pin [PIN]'
                    }),
                    arguments: {
                        PIN: {
                            type: 'number',
                            defaultValue: '2',
                            menu: 'digitalPinMenu'
                        }
                    }
                }
            ],

            menus: {},

            codeTemplates: [
                {
                    opcode: 'pir_motionDetected',
                    type: 'boolean',
                    arduino: {
                        code: '(digitalRead({{PIN}}) == HIGH)',
                        setup: ['pinMode({{PIN}}, INPUT);'],
                        includes: []
                    },
                    python: {
                        code: '(pin_{{PIN}}.value() == 1)',
                        setup: ['pin_{{PIN}} = Pin({{PIN}}, Pin.IN)'],
                        imports: ['from machine import Pin']
                    }
                },
                {
                    opcode: 'pir_waitMotion',
                    type: 'command',
                    arduino: {
                        code: 'while (digitalRead({{PIN}}) == LOW) { delay(10); }',
                        setup: ['pinMode({{PIN}}, INPUT);'],
                        includes: []
                    },
                    python: {
                        code: 'while pin_{{PIN}}.value() == 0:\n    time.sleep_ms(10)',
                        setup: ['pin_{{PIN}} = Pin({{PIN}}, Pin.IN)'],
                        imports: ['from machine import Pin', 'import time']
                    }
                }
            ]
        };
    }

    pir_motionDetected (args) {
        return this.simulateDigitalRead() === 1;
    }

    pir_waitMotion (args) {
        return Promise.resolve();
    }
}

export default PIRSensorExtension;
